import { Api } from '../api';
import { ListInputItemOptions } from '../filter/model';
import { addListInputItems } from '../filter/slice';
import {
  CreateSurveyFormRequest,
  GetSurveyFormByIdRequest,
  GetSurveyFormByIdResponse,
  GetSurveyFormDetailsByIdRequest,
  GetSurveyFormDetailsByIdResponse,
  ListSurveyFormsRequest,
  ListSurveyFormsResponse,
  SubmitSurveyFormRequest,
  SurveyDetailsRequest,
  SurveyDetailsResponse,
  UpdateSurveyFormByIdRequest,
} from './model';

export const SurveyFormsApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    getSurveyFormById: builder.query<
      GetSurveyFormByIdResponse,
      GetSurveyFormByIdRequest
    >({
      query(arg) {
        return {
          url: `/hub/bot/api/v1/forms/${arg?.formId}`,
          params: arg?.params,
          method: 'GET',
        };
      },
    }),
    submitSurveyForm: builder.mutation<any, SubmitSurveyFormRequest>({
      query(arg) {
        return {
          url: `/hub/bot/api/v1/forms/${arg?.formId}/answers`,
          body: arg?.body,
          params: arg?.params,
          method: 'POST',
        };
      },
    }),
    listSurveyForms: builder.query<
      ListSurveyFormsResponse,
      ListSurveyFormsRequest
    >({
      query(arg) {
        return {
          url: '/hub/bot/api/v1/forms',
          params: arg?.params,
        };
      },
      async onQueryStarted(request, { dispatch, queryFulfilled }) {
        queryFulfilled.then((response) => {
          const statusArray = response?.data?.filters?.statuses?.map(
            (status) => ({
              id: status,
              value: status,
              eitherOr: true,
              selected: false,
            })
          );

          const typeArray = response?.data?.filters?.types?.map((type) => ({
            id: type,
            value: type,
            eitherOr: false,
            selected: false,
          }));

          const customerArray = response?.data?.filters?.customers?.map(
            (customer) => ({
              id: customer?.id,
              value: customer?.name,
              eitherOr: false,
              selected: false,
            })
          );

          dispatch(
            addListInputItems({
              key: ListInputItemOptions.formType,
              inputItems: typeArray,
            })
          );
          dispatch(
            addListInputItems({
              key: ListInputItemOptions.formStatus,
              inputItems: statusArray,
            })
          );
          dispatch(
            addListInputItems({
              key: ListInputItemOptions.formCustomers,
              inputItems: customerArray,
            })
          );
        });
      },
    }),
    surveyDetails: builder.query<SurveyDetailsResponse, SurveyDetailsRequest>({
      query(arg) {
        return {
          url: `/hub/bot/api/v1/forms/${arg?.formId}/answers`,
          method: 'GET',
          params: arg?.params,
        };
      },
    }),
    createSurveyForm: builder.mutation<any, CreateSurveyFormRequest>({
      query(arg) {
        return {
          url: '/hub/bot/api/v1/forms',
          method: 'POST',
          body: arg.body,
          params: arg.params,
        };
      },
    }),
    updateSurveyFormById: builder.query<any, UpdateSurveyFormByIdRequest>({
      query(arg) {
        return {
          url: `/hub/bot/api/v1/forms/${arg?.formId}`,
          params: arg?.params,
          body: arg?.body,
          method: 'PUT',
        };
      },
    }),
    getSurveyFormDetailsById: builder.query<
      GetSurveyFormDetailsByIdResponse,
      GetSurveyFormDetailsByIdRequest
    >({
      query(arg) {
        return {
          url: `/hub/bot/api/v1/forms/answers/${arg?.answerId}`,
          params: arg?.params,
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useLazyGetSurveyFormByIdQuery,
  useSubmitSurveyFormMutation,
  useLazyListSurveyFormsQuery,
  useLazySurveyDetailsQuery,
  useCreateSurveyFormMutation,
  useLazyUpdateSurveyFormByIdQuery,
  useLazyGetSurveyFormDetailsByIdQuery,
} = SurveyFormsApi;
